import React from 'react';
import PageHero from '../components/PageHero';
import { useContent } from '../content/ContentContext';
import { renderRich, renderMultiline } from '../utils/text';

const BODY_FALLBACK = `## 1. Titolare del trattamento

Il titolare del trattamento dei dati personali è **Moto Club Insolita Sardegna**, con sede in Via Vincenzo Piro, Olbia. Per qualsiasi richiesta relativa al trattamento dei tuoi dati puoi scrivere a info@insolitasardegna.com.

## 2. Dati che raccogliamo

Trattiamo esclusivamente i dati necessari a erogare i nostri servizi:

- **Dati di contatto e anagrafici** (nome, cognome, email, telefono) che ci fornisci per il tesseramento, la prenotazione di tour ed eventi o tramite i moduli di contatto.
- **Dati di prenotazione** relativi a tour, corsi e gare a cui scegli di partecipare.
- **Dati di navigazione** raccolti automaticamente dal sito (indirizzo IP, tipo di browser, pagine visitate) per finalità tecniche e statistiche.

## 3. Finalità e base giuridica

Utilizziamo i tuoi dati per:

- gestire il tesseramento e le iscrizioni alle attività del club (esecuzione di un contratto);
- gestire prenotazioni, conferme e comunicazioni relative a tour ed eventi (esecuzione di un contratto);
- rispondere alle tue richieste di informazioni (legittimo interesse);
- adempiere agli obblighi di legge, fiscali e assicurativi (obbligo legale).

## 4. Conservazione dei dati

Conserviamo i dati personali per il tempo strettamente necessario alle finalità indicate e, in ogni caso, nei limiti dei termini di legge (ad esempio per gli obblighi contabili e fiscali). Al termine del periodo di conservazione i dati vengono cancellati o resi anonimi.

## 5. Comunicazione dei dati

I dati non vengono diffusi né ceduti a terzi per finalità di marketing. Possono essere trattati da soggetti che ci forniscono servizi (hosting, gestione dei pagamenti, invio di email) nominati responsabili del trattamento, e comunicati ad autorità e organismi sportivi quando previsto dalla legge o necessario per la partecipazione alle attività.

## 6. Pagamenti

I pagamenti online (caparre e quote) sono gestiti tramite fornitori esterni di servizi di pagamento. I dati della tua carta sono trattati direttamente dal fornitore di pagamento e non vengono conservati sui nostri sistemi.

## 7. Cookie

Il sito utilizza cookie tecnici necessari al corretto funzionamento delle pagine. Eventuali cookie di terze parti (es. mappe) vengono attivati solo per fornire le relative funzionalità.

## 8. I tuoi diritti

In qualità di interessato hai diritto di accedere ai tuoi dati, chiederne la rettifica o la cancellazione, limitarne od opporti al trattamento e richiederne la portabilità. Puoi esercitare questi diritti in ogni momento scrivendo a info@insolitasardegna.com. Hai inoltre il diritto di proporre reclamo all'Autorità Garante per la protezione dei dati personali.

## 9. Modifiche

Ci riserviamo di aggiornare la presente informativa. Le eventuali modifiche saranno pubblicate su questa pagina con l'indicazione della data di ultimo aggiornamento.`;

const Privacy: React.FC = () => {
  const { t, img } = useContent();
  const title = t('legal.privacy.title', 'Privacy Policy');

  return (
    <>
      <PageHero image={img('privacy.hero.image', '/img/insolita-sardegna-moto.jpg')} crumb="Privacy Policy" title={title} minHeight="42svh" />

      <section className="sec">
        <div className="wrap">
          <div className="legal reveal">
            <p>{renderMultiline(t('legal.privacy.updated', 'Ultimo aggiornamento: 7 agosto 2026'))}</p>
            {renderRich(t('legal.privacy.body', BODY_FALLBACK))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy;
